/* 孫吳傳・第 6 章：神亭酣鬥（興平二年，195）
 * 史實：《三國志·太史慈傳》「慈與策遇於神亭。時策從騎十三，皆韓當、宋謙、黃蓋輩也。慈便前鬬，正與策對。
 *       策刺慈馬，而擥得慈項上手戟，慈亦得策兜鍪。會兩家兵騎並各來赴，於是解散。」
 * 流程：孫策帶十三騎出營，避開大路上的哨兵往北繞上神亭 → 太史慈只帶一騎衝來，兩人在嶺上單挑 →
 *       單挑看「架勢」：被打中架勢就掉，掉光了就破勢；趁對方破勢時近身打中，就奪下對方的東西（孫策奪手戟、太史慈奪兜鍪）→
 *       兩家兵馬趕到，混戰一陣後各自解散 → 帶十三騎回營。
 * 單挑時兩人都打不死（生命最低留兩成），比的是架勢；孫策破勢三次就被擒，算戰敗。
 * 對白是遊戲的演繹；旁白卡只引原文。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';

const CAMP = [900, 2900], TING = [3950, 1750], EAST = [6800, 2500];
const ARENA_R = 380, DUEL_LV = 8, DUEL_T = 100, DUEL_TAKEN = -0.5;
const POS_K = { me: 130, tsc: 220 }; // 架勢掉多快：太史慈掉得比孫策快得多（玩家這邊有利；10/28 試玩太難，調鬆）
const BREAKS = 4; // 孫策破勢幾次被擒
const RIDERS = ['韓當', '宋謙', '黃蓋'].concat(Array(10).fill('從騎'));
// 劉繇兵：藍灰色號衣（不是黃巾）
const LIUYAO = Object.assign({}, SG.SOLDIERS.wei, { id: 'liuyao-soldier', name: '劉繇兵', faction: 'neutral',
  c: Object.assign({}, SG.SOLDIERS.wei.c, { armor: '#5d6a78', sleeve: '#3f4a56', cloth: '#3f4a56', plume: '#9aa7b5' }) });
delete LIUYAO._anims; delete LIUYAO._ghost;
// 大路上的哨兵：[起點, 終點]，在兩點之間來回走
const SENTRY = [
  [[1900, 3050], [2900, 2980]], [[2700, 2950], [3450, 2700]], [[3350, 2850], [3700, 2350]], [[4100, 2850], [4900, 2700]],
  [[2300, 2350], [2600, 2900]], [[3300, 2100], [3600, 1950]],
];
const DUEL_HINT = [
  '單挑看的是頭上的「架勢」：打中他，他的架勢就掉；架勢掉光就破勢，會呆站一陣子。',
  '趁太史慈破勢時近身打中他，就能奪下他的手戟。反過來，你破勢時被他打中，兜鍪就被奪走。',
  '他會等你出招再反擊，別一次把招放光。破勢四次就會被擒。',
];

export function setLevel(w, u, lv) {
  const need = SG.expToLevel(lv) - u.exp;
  if (need > 0) w.addExp(u, need / w.tune.exp + 1, true);
}
// 單挑場地：嶺頂的一圈，兩人都出不去
function keepIn(u) {
  const dx = u.x - TING[0], dy = (u.y - TING[1]) / SG.K, e = Math.hypot(dx, dy);
  if (e > ARENA_R) { u.x = TING[0] + (dx / e) * ARENA_R; u.y = TING[1] + (dy / e) * ARENA_R * SG.K; }
}
// 架勢：生命掉多少，架勢就跟著掉（單挑時受到的傷害減半，掉六成生命左右才破勢）；兩秒沒挨打就慢慢回；破勢後站起來回一點血
function posture(m, w, u, dt) {
  const lost = Math.max(0, u.posHp - u.hp);
  if (lost > 0) { u.pos -= (lost / u.maxHp) * u.posK; u.posT = 0; }
  if (u.hp < u.maxHp * 0.2) u.hp = u.maxHp * 0.2; // 單挑打不死
  u.posHp = u.hp;
  if (u.broken > 0) {
    u.broken -= dt;
    if (u.broken <= 0) { u.broken = 0; u.pos = 55; u.hp = u.posHp = Math.min(u.maxHp, u.hp + u.maxHp * 0.25); }
    return;
  }
  u.posT += dt;
  if (u.posT > 2) u.pos = Math.min(100, u.pos + 9 * dt);
  if (u.pos > 0) return;
  // 破勢：呆站 2.2 秒
  u.pos = 0; u.broken = 2.2; u.brokeAt = w.t; u.breaks = (u.breaks || 0) + 1;
  u.st.stun = Math.max(u.st.stun, 2.2); u.act = null; u.input = Object.assign(u.input, { target: null, engage: false, skill: null, moveTo: null });
  w.dmgEvents.push({ x: u.x, y: u.y - 70, text: '破勢！', team: u.team, src: u.id, tgt: u.id });
  w.fx({ k: 'spark', x: u.x, y: u.y - 30, col: '#ffe28a' });
}
// 奪物：對方破勢時近身打中他（打中的時間在破勢之後）
const hitWhileBroken = (w, by, t) => t.broken > 0 && t.dmgBy[by.id] >= t.brokeAt && SG.gd(by.x, by.y, t.x, t.y) < 180;

// 太史慈的單挑：繞著孫策走，等孫策出招（放技能）就衝上來反擊；孫策破勢就上前奪兜鍪
function duelAI(m, w, u, me, dt) {
  const I = u.input, S = u.duel || (u.duel = { mode: 'circle', t: 1.5, dir: 1 });
  if (!u.alive || u.broken > 0 || u.st.stun > 0) return;
  const d = SG.gd(u.x, u.y, me.x, me.y), ready = (i) => u.cd[i] <= 0 && u.skillLv[i] > 0 && !u.act;
  if (me.broken > 0 && !m.vars.helm) { I.target = me; I.engage = true; I.moveTo = null; return; }
  S.t -= dt;
  if (me.act && me.act.kind === 'skill' && d < 460 && S.mode === 'circle') { S.mode = 'press'; S.t = 1.6; } // 你出招了：換他上
  if (ready(0) && d > 230 && d < 470 && SG.rand() < dt * 0.35) { I.skill = { i: 0, x: me.x, y: me.y }; return; }
  if (S.mode === 'press') {
    I.target = me; I.engage = true; I.moveTo = null;
    if (ready(1) && d < 260) I.skill = { i: 1, x: u.x, y: u.y };
    else if (ready(2) && !m.vars.ji && d < 200) I.skill = { i: 2, x: me.x, y: me.y };
    if (S.t <= 0) { S.mode = 'circle'; S.t = 2 + SG.rand() * 2; if (SG.rand() < 0.4) S.dir = -S.dir; }
    return;
  }
  // 繞圈：保持兩百多的距離，往側邊繞
  I.target = null; I.engage = false;
  const a = Math.atan2((u.y - me.y) / SG.K, u.x - me.x) + S.dir * 0.7;
  let tx = me.x + Math.cos(a) * 270, ty = me.y + Math.sin(a) * 270 * SG.K;
  const ex = (tx - TING[0]) / ARENA_R, ey = (ty - TING[1]) / (ARENA_R * SG.K), e = Math.hypot(ex, ey);
  if (e > 0.9) { tx = TING[0] + (ex / e) * 0.9 * ARENA_R; ty = TING[1] + (ey / e) * 0.9 * ARENA_R * SG.K; S.dir = -S.dir; }
  I.moveTo = [tx, ty];
  if (S.t <= 0) { S.mode = 'press'; S.t = 1.2 + SG.rand() * 0.8; }
}

// 程普：跟著孫策，看到敵人就打
function npc(w, u, lead) {
  const I = u.input;
  if (!u.alive) return;
  let foe = null, bd = 520;
  for (const t of w.units) if (w.isEnemy(u, t) && t.team === 1) { const d = SG.gd(u.x, u.y, t.x, t.y); if (d < bd) { bd = d; foe = t; } }
  if (foe) {
    I.target = foe; I.engage = true;
    if (!u.act && SG.rand() < 0.04) { const i = [0, 1, 2].find((k) => u.cd[k] <= 0 && u.skillLv[k] > 0); if (i !== undefined) I.skill = { i, x: foe.x, y: foe.y }; }
    return;
  }
  I.target = null; I.engage = false;
  if (lead && lead.alive && SG.gd(u.x, u.y, lead.x, lead.y) > 260) I.moveTo = [lead.x - 110 * lead.f, lead.y + 50];
}
const rout = (m, w, list, to) => {
  for (const u of m.alive(list)) { u.rout = true; u.untargetable = true; u.target = null; u.aggro = null; u.patrol = null; u.home = to.slice(); u.ms = 300; }
  m.after(5, () => { for (const u of list) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; } });
};

export default {
  id: 'sunwu-6', map: 'shenting', hero: 'sunce',
  title: '第 5 章　神亭酣鬥', year: '興平二年（195）',
  words: { ally: '從騎', foe: '劉繇兵' },
  brief: {
    quote: [
      { text: '慈與策遇於神亭。時策從騎十三，皆韓當、宋謙、黃蓋輩也。慈便前鬬，正與策對。', src: '《三國志·吳書·太史慈傳》' },
    ],
    text: '孫堅攻劉表，在峴山中箭身亡。孫策依附袁術，帶著父親的舊部借兵渡江，破劉繇的牛渚營，進逼曲阿。太史慈投奔同郡的劉繇，正奉命出去偵察。',
    goals: ['帶十三騎上神亭探查劉繇軍', '和太史慈單挑', '帶十三騎回營'],
  },
  stars: [
    { text: '如史：奪下手戟，兜鍪也被奪走', ok: (m) => !!(m.vars.ji && m.vars.helm) },
    { text: '上神亭的路上沒有被哨兵發現', ok: (m) => !m.vars.spotted },
    { text: '十三騎全數回營', ok: (m) => m.stats.lost === 0 },
  ],
  steps: [
    { // 1. 出營：帶十三騎上神亭，避開大路上的哨兵
      enter(m, w) {
        const me = w.player;
        setLevel(w, me, DUEL_LV);
        m.card('策渡江攻繇牛渚營，盡得邸閣糧穀、戰具。', '《江表傳》（〈孫策傳〉裴注）');
        m.vars.riders = RIDERS.map((name, i) => { const u = m.recruit(me.x - 80 - (i % 4) * 50, me.y - 90 + Math.floor(i / 4) * 60, name); m.join(u, me); return u; });
        m.vars.sentries = SENTRY.map(([a, b]) => { const u = m.foe('huangjin', a[0], a[1], { spec: LIUYAO, name: '劉繇兵' }); m.patrol(u, [a, b]); return u; });
        m.mark('ting', TING[0], TING[1], '神亭');
        m.obj('ting', '帶十三騎上神亭，探查劉繇軍');
        m.after(1.5, () => m.line('孫策', '劉繇的營就在東邊。走，上神亭去看看虛實！'));
        m.after(5, () => m.i === 0 && m.line('提示', `孫策現在 ${me.lv} 級，有技能點可以分配：Alt＋Q／W／E／R（或點技能上的 ＋）學技能。`));
        m.after(11, () => m.i === 0 && m.line('韓當', '大路上有劉繇的哨兵來回走。從北邊的樵徑繞過去，沿路的草叢可以躲。'));
      },
      tick(m, w) {
        // 哨兵看到我們（追上來）就算被發現：附近的哨兵都會趕過來
        const t = m.vars.sentries.map((u) => u.alive && u.target && u.target.alive && u.target.team === 0 && u.target).find(Boolean);
        if (t && !m.vars.spotted) {
          m.vars.spotted = true;
          m.line('劉繇兵', '有探子！快來人！');
          for (const u of m.vars.sentries) if (u.alive && !u.target && SG.gd(u.x, u.y, t.x, t.y) < 900) { u.target = t; u.think = 0.35; }
        }
        return m.near(w.player, TING[0], TING[1], 300);
      },
    },
    { // 2. 太史慈只帶一騎衝來：兩人單挑，十三騎退到圈外
      enter(m, w) {
        const me = w.player;
        m.done('ting'); m.unmark('ting');
        for (const u of m.alive(m.vars.sentries)) { u.target = null; u.aggro = null; }
        const tsc = w.addHero(SG.HEROES.find((h) => h.id === 'taishici'), 1, false);
        tsc.human = true; tsc.npc = true; // 不走一般電腦，由 duelAI 操作
        tsc.x = TING[0] + ARENA_R - 40; tsc.y = TING[1]; tsc.f = -1;
        setLevel(w, tsc, me.lv);
        tsc.skillLv = SG.skillLevels(tsc.spec, tsc.lv).L; tsc.skillLv[3] = 0; // 只用手戟，不換弓
        w.recalc(tsc); tsc.hp = tsc.maxHp; tsc.mp = tsc.maxMp;
        m.vars.tsc = tsc;
        m.vars.rider = m.foe('huangjin', TING[0] + ARENA_R + 140, TING[1] + 60, { spec: LIUYAO, name: '太史慈的從騎', untargetable: true });
        // 十三騎退到圈外，站著看
        m.alive(m.vars.riders).forEach((u, i) => {
          const a = Math.PI * (0.62 + (i / 12) * 0.76);
          u.owner = null; u.untargetable = true; u.home = [TING[0] + Math.cos(a) * (ARENA_R + 120), TING[1] + Math.sin(a) * (ARENA_R + 120) * SG.K];
        });
        for (const u of [me, tsc]) { u.posK = u === me ? POS_K.me : POS_K.tsc; u.hp = u.maxHp; u.pos = 100; u.posHp = u.hp; u.posT = 9; u.broken = 0; u.breaks = 0; w.addBuff(u, { id: '單挑', t: 9999, taken: DUEL_TAKEN }); }
        // 單挑打不死：致命的一擊只留一點血（下一步 posture 再拉回兩成）
        const pk = w.xPreKill;
        w.xPreKill = function (src, t) { if (m.vars.duel && (t === me || t === tsc)) { t.hp = 1; return true; } return pk.call(this, src, t); };
        m.vars.duel = { t: 0 }; m.vars.arena = { x: TING[0], y: TING[1], r: ARENA_R }; m.vars.duelers = [me, tsc];
        m.big('神亭酣鬥');
        m.card('慈便前鬬，正與策對。', '《太史慈傳》');
        m.after(1.2, () => m.line('太史慈', '我乃東萊太史子義！孫策何在？'));
        m.after(3.2, () => m.line('孫策', '我就是孫伯符！各位退下，讓我會會他！'));
        DUEL_HINT.forEach((s, i) => m.after(5 + i * 5, () => { if (m.vars.duel) m.line('提示', s); }));
        m.obj('ji', '奪下太史慈的手戟');
      },
      tick(m, w, dt) {
        const me = w.player, tsc = m.vars.tsc, D = m.vars.duel;
        D.t += dt;
        for (const u of m.alive(m.vars.riders.concat(m.vars.sentries))) { u.target = null; u.aggro = null; u.think = 0.35; } // 圈外的人只看不打
        const r = m.vars.rider; if (r.alive) { r.target = null; r.think = 0.35; r.home = [TING[0] + ARENA_R + 140, TING[1] + 60]; }
        keepIn(me); keepIn(tsc);
        posture(m, w, me, dt); posture(m, w, tsc, dt);
        duelAI(m, w, tsc, me, dt);
        if (!m.vars.ji && hitWhileBroken(w, me, tsc)) {
          m.vars.ji = w.t; m.done('ji');
          m.big('奪下手戟！');
          m.card('策刺慈馬，而擥得慈項上手戟。', '《太史慈傳》');
          w.addBuff(tsc, { id: '失了手戟', t: 9999, neg: true, atkP: -0.25, as: -25 });
          tsc.broken = 0.01; // 奪完就讓他起來
        }
        if (!m.vars.helm && hitWhileBroken(w, tsc, me)) {
          m.vars.helm = w.t;
          m.big('兜鍪被奪！');
          m.card('慈亦得策兜鍪。', '《太史慈傳》');
          w.addBuff(me, { id: '失了兜鍪', t: 9999, neg: true, armor: -Math.max(0, me.armor) * 0.35 });
          me.broken = 0.01;
          tsc.input.target = null; tsc.input.engage = false; tsc.duel.mode = 'circle'; tsc.duel.t = 1.5;
        }
        if (me.breaks >= BREAKS) { m.lose(`孫策破勢 ${BREAKS} 次，被太史慈擒住`); return false; }
        const o = m.get('ji');
        if (o && !o.done) o.text = `奪下太史慈的手戟（${Math.max(0, Math.ceil(DUEL_T - D.t))} 秒內兩家兵馬就會趕到）`;
        return (m.vars.ji && m.vars.helm && w.t - Math.max(m.vars.ji, m.vars.helm) > 2) || D.t > DUEL_T;
      },
    },
    { // 3. 兩家兵騎趕到：混戰一陣
      enter(m, w) {
        const me = w.player, tsc = m.vars.tsc;
        m.vars.duel = null;
        if (!m.get('ji').done) m.drop('ji');
        for (const u of [me, tsc]) { u.broken = 0; u.st.stun = 0; u.hp = Math.max(u.hp, u.maxHp * 0.5); w.addBuff(u, { id: '單挑', t: 0.01 }); }
        m.card('會兩家兵騎並各來赴。', '《太史慈傳》');
        m.line('太史慈', '今日未分勝負，改日再戰！');
        tsc.untargetable = true; tsc.input = { moveTo: [EAST[0], EAST[1]] };
        m.after(4, () => { w.units = w.units.filter((u) => u !== tsc); }); // 武將陣亡會復活：直接從場上拿掉
        for (const u of m.alive(m.vars.riders)) { u.untargetable = false; m.join(u, me); }
        const r = m.vars.rider; r.untargetable = false;
        m.vars.horde = [r].concat(Array.from({ length: 8 }, (_, i) => m.foe('huangjin', TING[0] + 520 + (i % 3) * 70, TING[1] - 120 + Math.floor(i / 3) * 110, { spec: LIUYAO, name: '劉繇騎', ms: 300 })));
        const cp = w.addHero(SG.HEROES.find((h) => h.id === 'chengpu'), 0, false);
        cp.human = true; cp.npc = true; cp.x = TING[0] - 520; cp.y = TING[1] + 160; setLevel(w, cp, me.lv);
        cp.skillLv = SG.skillLevels(cp.spec, cp.lv).L; w.recalc(cp); cp.hp = cp.maxHp;
        m.vars.cp = cp;
        m.after(1.2, () => m.line('程普', '伯符！我們來了！'));
        m.obj('melee', '擊退劉繇的援兵');
      },
      tick(m) { return !m.alive(m.vars.horde).length || m.t > 30; },
    },
    { // 4. 解散，回營
      enter(m, w) {
        m.done('melee');
        m.card('於是解散。', '《太史慈傳》');
        rout(m, w, m.vars.horde, EAST);
        m.after(1.5, () => m.line('孫策', '太史子義，真是好漢。收兵回營！'));
        m.mark('camp', CAMP[0], CAMP[1], '孫策營');
        m.obj('camp', '帶十三騎回營');
      },
      tick(m, w) {
        if (!m.near(w.player, CAMP[0], CAMP[1], 320)) return false;
        m.done('camp'); m.win();
        return false;
      },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('孫策陣亡'); return; }
    if (m.vars.cp) npc(w, m.vars.cp, w.player);
  },
};
